export const TRIGGER_NOTIFICATION_RECIPIENTS = [
  'andi.hyseni@foleja.com',
  'shpend.bakalli@foleja.com',
];

export const isTriggerNotificationRecipient = (email?: string): boolean =>
  !!email && TRIGGER_NOTIFICATION_RECIPIENTS.includes(email.toLowerCase());
